module.exports = __webpack_public_path__ + "img/banner_bag_mobile_947556e.webp";